import { IEnumerationItem } from "features/configuration/models/Enumeration"
import { BaseType, DataType } from "features/configuration/models/ExtensionType"
import { IRegistration } from "features/production/models/Registration";
import { ITeacher } from "./Teacher";
import { IBilling } from "features/finance/models/Billing";

export type SubjectScheduleType = 'recurrent' | 'exceptional' ;

export interface ISchoolYear {
    id: number,
    
    year: number,
    name: string,
    startDate: Date,
    endDate: Date,
    isActive: boolean,
    
    schoolYearBillingTypes: ISchoolYearBillingType[],
    schoolYearClassTemplates: ISchoolYearClassTemplate[],
    schoolYearPeriods: ISchoolYearPeriod[],

    schoolYearMaterials: ISchoolYearMaterial[],
    
    currentExtensionAlias: string,    
    currentExtensionDescription: string,
    currentExtensionTypeId: number,
    currentExtensionTypeName: string,

    currentExtensionTypeX: DataType,
    currentExtensionTypeBaseType: BaseType,

    registrationSequenceExpression: string,
    registrationCodeExpression: string,

    studentSequenceExpression: string,
    studentCodeExpression: string,

    category: string,

    studentSequenceDefinitionId: number,
    registrationSequenceDefinitionId: number,
    studentSequenceDefinitionName: string,
    registrationSequenceDefinitionName: string,


    allowPartialRegistrationPayment: boolean,
    allowRegistrationValidationWithoutPayment: boolean,
    validateRegistrationByAdmission: boolean,

    schoolYearRegistrationExtensions: ISchoolYearRegistrationExtension[],

    schoolYearTimeSlots: ISchoolYearTimeSlot[]
  }

  export interface ISchoolYearBillingType {
    id: number,
    schoolYearId: number,
    billingTypeId: number,

    dueDate: Date,
    obligatoryExpression: string,
    defaultAmountExpression: string,

    maxNumberPerRegistration: number,

    startDate: Date,
    endDate: Date,

    schoolYearTarifications: ISchoolYearTarification[],

    billingTypeName: string
  }


  export interface ISchoolYearTimeSlot {
    id: number,
    schoolYearId: number,
    
    category: string,
    startTime: Date,
    endTime: Date,
    isRestTime: boolean
  }

  export interface ISchoolYearClassTemplate {
    id: number,
    schoolYearId: number,
    classTemplateId: number,
    isActive: boolean,
    countReportCard: number,
    reportCardMark: number,
    defaultSuccessMark: number,

    appreciationSystemCode: string,

    classTemplateName: string,
    classTemplateDescription: string,
    classTemplateLevel: number,

    studyCycle: string,
    studyLevel: string,
    studySection: string,
    studyLanguage: string,

    schoolYearStartDate: Date,
    schoolYearEndDate: Date,

    minReportCard: string,
    maxReportCard: string,

    hasOfficialExam: boolean,
    officialExamName: string,
    officialExamStartDate: Date,

    schoolYearClasses: ISchoolYearClass[],
    schoolYearTemplateSubjects: ISchoolYearTemplateSubject[],

    schoolYearClassTemplateOfficialExams: ISchoolYearClassTemplateOfficialExam[]
  }

  export interface ISchoolYearTemplateSubject {
    id: number,
    schoolYearClassTemplateId: number,

    classTemplateId: number,
    
    category: string,
    subject: string,

    longName: string,
    shortName: string,

    coefficient: number,   
    reportCard: string,
    maxMark: number,

    reportCardOrder: number,

    schoolYearTemplateSubjectExamSchedules: ISchoolYearTemplateSubjectExamSchedule[],

    schoolYearTemplateSubjectBooks: ISchoolYearTemplateSubjectBook[],
    schoolYearTemplateSubjectCompetences: ISchoolYearTemplateSubjectCompetence[];

    // for display purpose.
    schoolYearTemplateSubjectPeriods: {
        schoolYearPeriodId: number, schoolYearPeriodName: string,
        schoolYearTemplateSubjectExamSchedules: ISchoolYearTemplateSubjectExamSchedule[]} []
  }

  export interface ISchoolYearTemplateSubjectBook {
    id: number,
    schoolYearTemplateSubjectId: number,
    title: string,
    authors: string,
    isbn: string,
    publisher: string,
    publicationDate: Date,
    isOfficial: boolean,
    edition: string,
    language: string
  }

  export interface ISchoolYearTemplateSubjectCompetence {
    id: number,
    schoolYearTemplateSubjectId: number,

    title: string,
    description: string,

    schoolYearTemplateSubjectLongName: string
  }

  export interface ISchoolYearTemplateSubjectExamSchedule {
    id: number,
    schoolYearTemplateSubjectId: number,
    schoolYearPeriodExamId: number,

    examDate: Date,
    startTime: Date,
    endTime: Date,
    maxMark: number,
    
    schoolYearPeriodId: number,
    schoolYearPeriodExamName: string,

    subjectLongName: string,

    examDateInput: string,
    startTimeInput: string,
    endTimeInput: string,

    schoolYearTemplateSubjectExamScheduleCompetences: ISchoolYearTemplateSubjectExamScheduleCompetence[]
  }

  export interface ISchoolYearTemplateSubjectExamScheduleCompetence {
    id: number,
    schoolYearTemplateSubjectExamScheduleId: number,
    schoolYearTemplateSubjectCompetenceId: number,

    schoolYearTemplateSubjectCompetenceDescription: number,
    
    reportCardOrder: number,
    maxMark: number,

    subjectLongName: string,
    schoolYearPeriodExamName: string,
    title: string,
  }

  export interface ISchoolYearPeriod {
    id: number,
    schoolYearId: number,
    
    name: string,

    startDate: Date,
    endDate: Date,

    markAlias: string,

    schoolYearPeriodExams: ISchoolYearPeriodExam[]
  }

  export interface ISchoolYearPeriodExam {
    id: number,
    schoolYearPeriodId: number,
    
    name: string,
    startDate: Date,
    endDate: Date,
    gradeWeight: number,

    markAlias: string,

    schoolYearTemplateSubjectExamSchedules: ISchoolYearTemplateSubjectExamSchedule[]
  }


  export interface ISchoolYearClass {
    id: number,
    schoolYearId: number,
    studyType: string,

    schoolYearClassTemplateId: number,

    classTemplateId: number,

    name: string,

    classroomId: number,
    isActive: boolean,
    fullTeacherId: number,
    substituteTeacherId: number,

    supervisorId: number,
    substituteSupervisorId: number,

    classTemplateName: string,
    isClassTemplateActive: boolean,
    studyLevel: string,
    studySection: string,
    studyLanguage: string,
    classroomName: string,

    studyCycle: string,
    classOrder: number,

    fullTeacherName: string,
    substituteTeacherName: string,

    supervisorFullName: string,
    substituteSupervisorFullName: string,

    schoolYearClassSubjects: ISchoolYearClassSubject[],

    registrations?: IRegistration[],

    amount: number,
    dueAmount: number,
    unpaidAmount: number,
    amountPaid: number,

    countStudents: number,
    countGirls: number,
    countBoys: number,

    currentSchoolYearPeriodId?: number,
    currentSchoolYearPeriodExamId?: number,
    currentSchoolYearTemplateSubjectExamScheduleId?: number,
    currentConsiderMarkOfZeroAsMarkNotExist?: boolean,

    currentSchoolYearClassSubjectExamSupervisors: ITeacher[],

    currentSchoolYearClassSubjectExamStatusPurpose: string
  }


  export interface ISchoolYearClassSubject {
    id: number,
    schoolYearTemplateSubjectId: number,
    schoolYearClassId: number,
    teacherId: number,

    schoolYearClassName: string,
    teacherName: string,

    schoolYearTemplateSubjectLongName: string,

    schoolYearClassSubjectSchedules: ISchoolYearClassSubjectSchedule[]
    // for display purpose. We remove it, because we want it simple... no schedule per period.
    // schoolYearClassSubjectPeriods: {
    //   schoolYearPeriodId: number, schoolYearPeriodName: string,
    //   schoolYearClassSubjectSchedules: ISchoolYearClassSubjectSchedule[]} []

  }

  export interface ISchoolYearClassSubjectSchedule {
    id: number,

    schoolYearClassSubjectId: number,
    schoolYearPeriodId: number,
    schoolYearTimeSlotId: number,

    startTime: Date,
    endTime: Date,
    type:	SubjectScheduleType,
    dayOfWeek: string,
    scheduledDate: Date,

    description: string // this will describe what to put in list: day of week or specific date.
  }

  export interface ISchoolYearClassSubjectExamSchedule {
    id: number,

    schoolYearTemplateSubjectExamScheduleId: number,
    schoolYearClassId: number,
    status: string,
    statusDate: Date,
    statusPurpose: string,

    subjectShortName: string,
    subjectLongName: string,

    schoolYearTemplateSubjectId: number,
    schoolYearPeriodExamId: number;

    maxMark: number,
    
  }

  export interface ISchoolYearTarification {
    id: number,
    schoolYearBillingTypeId: number,
    studyType: string,
    classTemplateId: number,

    amountExpression: string,
    
    billingTypeName: string,
    classTemplateName: string
  }

  export interface ISchoolYearRegistrationExtension {
    id: number,
    extensionTypeId: number,    
    alias: string,
    description: string,
    schoolYearId: number,

    extensionTypeName: string,
  
    extensionEnumerationItems: IEnumerationItem[],

    type: DataType,
    baseType: BaseType,

    enumerationCode: string
  }

  export interface ISchoolYearMaterial {
    id: number,
    schoolYearId: number,
    schoolMaterialCode: string,
    conditionExpression: string,
    isGivenByStudent: boolean,

    billingTypeId: number,
    defaultAmountExpression: string
  }

export interface ISchoolYearClassTemplateOfficialExam {
    id: number,
    schoolYearClassTemplateId: number,
    schoolYearPeriodExamId: number,
    shortName: string,

    schoolYearPeriodExamName: string
  }


  export const defaultSchoolYear : ISchoolYear = {
    id: 0,

    year: 0,
    name: '',
    startDate: new Date(),
    endDate: new Date(),
    isActive: true,
  
    schoolYearBillingTypes: [],
    schoolYearClassTemplates: [],
    schoolYearPeriods: [],
    schoolYearMaterials: [],

    currentExtensionAlias: '',    
    currentExtensionDescription: '',
    currentExtensionTypeId: 0,
    currentExtensionTypeName: '',

    currentExtensionTypeX: 'text',
    currentExtensionTypeBaseType: 'string',

    registrationSequenceExpression: '',
    registrationCodeExpression: '',

    studentSequenceExpression: '',
    studentCodeExpression: '',

    category: '',

    studentSequenceDefinitionId: 0,
    registrationSequenceDefinitionId: 0,
    studentSequenceDefinitionName: '',
    registrationSequenceDefinitionName: '',

    allowPartialRegistrationPayment: true,
    allowRegistrationValidationWithoutPayment: true,
    validateRegistrationByAdmission: false,
    
    schoolYearRegistrationExtensions: [],

    schoolYearTimeSlots: []
  }

  export const defaultSchoolYearClassTemplate : ISchoolYearClassTemplate = {
    id: 0,
    schoolYearId: 0,
    classTemplateId: 0,
    isActive: true,
    countReportCard: 1,
    reportCardMark: 20,
    defaultSuccessMark: 10,
    appreciationSystemCode: '',

    classTemplateName: '',
    classTemplateDescription: '',
    classTemplateLevel: 0,

    studyCycle: '',
    studyLevel: '',
    studySection: '',
    studyLanguage: '',

    schoolYearStartDate: new Date(),
    schoolYearEndDate: new Date(),

    minReportCard: '',
    maxReportCard: '',

    hasOfficialExam: false,
    officialExamName: '',
    officialExamStartDate: new Date(),

    schoolYearClasses: [],
    schoolYearTemplateSubjects: [],

    schoolYearClassTemplateOfficialExams: []
  }

  export const defaultSchoolYearTemplateSubject : ISchoolYearTemplateSubject = {
    id: 0,
    schoolYearClassTemplateId: 0,

    classTemplateId: 0,
    
    category: '',
    subject: '',

    longName: '',
    shortName: '',

    coefficient: 0,   
    reportCard: '',
    maxMark: 20,

    reportCardOrder: 0,

    schoolYearTemplateSubjectExamSchedules: [],

    schoolYearTemplateSubjectBooks: [],
    schoolYearTemplateSubjectCompetences: [],

    schoolYearTemplateSubjectPeriods: []
  }

  export const defaultSchoolYearClass : ISchoolYearClass = {
    id: 0,
    schoolYearId: 0,
    studyType: '',

    schoolYearClassTemplateId: 0,
    classTemplateId: 0,

    name: '',

    classroomId: 0,
    isActive: true,
    fullTeacherId: 0,
    substituteTeacherId: 0,

    supervisorId: 0,
    substituteSupervisorId: 0,

    classTemplateName: '',
    isClassTemplateActive: true,
    studyLevel: '',
    studySection: '',
    studyLanguage: '',
    classroomName: '',

    studyCycle: '',
    classOrder: 0,

    fullTeacherName: '',
    substituteTeacherName: '',

    supervisorFullName: '',
    substituteSupervisorFullName: '',

    schoolYearClassSubjects: [],
    registrations: [],

    amount: 0,
    dueAmount: 0,
    unpaidAmount: 0,
    amountPaid: 0,

    countStudents: 0,
    countGirls: 0,
    countBoys: 0,

    currentSchoolYearPeriodId: 0,
    currentSchoolYearPeriodExamId: 0,
    currentSchoolYearTemplateSubjectExamScheduleId: 0,
    currentSchoolYearClassSubjectExamSupervisors: [],

    currentSchoolYearClassSubjectExamStatusPurpose: ''
  }
  
  export const defaultSchoolYearClassSubject : ISchoolYearClassSubject = {
    id: 0,

    schoolYearTemplateSubjectId: 0,
    schoolYearClassId: 0,
    teacherId: 0,

    schoolYearClassName: '',
    teacherName: '',

    schoolYearTemplateSubjectLongName: '',

    schoolYearClassSubjectSchedules: []
  }

  export const defaultSchoolYearPeriod : ISchoolYearPeriod = {
    id: 0,
    schoolYearId: 0,
    
    name: '',

    startDate: new Date(),
    endDate: new Date(),

    markAlias: '',

    schoolYearPeriodExams: []
  }

  export const defaultSchoolYearTemplateSubjectExamSchedule : ISchoolYearTemplateSubjectExamSchedule = {
    id: 0,
    schoolYearTemplateSubjectId: 0,
    schoolYearPeriodExamId: 0,

    examDate: new Date(),
    startTime: new Date(),
    endTime: new Date(),
    maxMark: 0,
    
    schoolYearPeriodId: 0,
    schoolYearPeriodExamName: '',

    subjectLongName: '',

    examDateInput: '',
    startTimeInput: '',
    endTimeInput: '',

    schoolYearTemplateSubjectExamScheduleCompetences: []
  }
  

  export const defaultSchoolYearTemplateSubjectCompetence : ISchoolYearTemplateSubjectCompetence = {
    id: 0,
    schoolYearTemplateSubjectId: 0,

    title: '',
    description: '',

    schoolYearTemplateSubjectLongName: ''
  }

  export const defaultSchoolYearTemplateSubjectExamScheduleCompetence : ISchoolYearTemplateSubjectExamScheduleCompetence = {
    id: 0,
    schoolYearTemplateSubjectExamScheduleId: 0,
    schoolYearTemplateSubjectCompetenceId: 0,

    schoolYearTemplateSubjectCompetenceDescription: 0,
    
    reportCardOrder: 0,
    maxMark: 0,

    subjectLongName: '',
    schoolYearPeriodExamName: '',
    title: ''
  }


  export interface ISchoolYearSearch {
    
    year: number,
    name: string
  }

  export interface ISchoolYearClassSearch {
    
    schoolYearId: number,
    name: string,
    studyType: string,
    studySection: string,    
    studyLanguage: string,    
    studyLevel: string,     
  }



  


  